import {McbGridOrderType} from "./enum/mcb-grid-order-type";

export class McbGridOrder {
  fieldName: string;
  type: McbGridOrderType;

  constructor(fieldName: string, type) {
    this.fieldName = fieldName;
    this.type = type;
  }
}
